function showStatusMessage(msg,timeout){
  timeout = timeout || 1500;
  $('.status-msg .inner-msg').html(msg);
  $('.status-msg').addClass('visible');
  setTimeout(function(){$('.status-msg').removeClass('visible');}, timeout);
}


localStorage.setItem('isCleanse', 'yes');

$(document).ready(function() {
  
  localStorage.setItem('cleanseSelections', '');
  
  
  $('.soups-selection-section button.addtocart').click(function(e) {  
    e.preventDefault();
    
    var _interval = $('.order-recurring-interval:checked').val();
    
    if (typeof _interval == 'undefined') {
     	showStatusMessage('Please select your order type');
      	return;
    }
    
    if (_interval === 'onetime') {  
   
  		$(".ro_widget").remove();
      
      	$(this).closest('form').attr('action', '/cart/add').submit();
    } else {
      
      var _soups = '';
      
      $('.product-form-wrapper .soup-table select').each(function() {
        
        _soups += '|' + $(this).find('option[value="' + $(this).val() + '"]').attr('data-handle');
        
      });
      
      _soups = _soups.substring(1);
      
      localStorage.setItem('cleanseSelections', _soups);
      
      $('.soups-selection-section .product-form .product-form__item--submit > .button').click();
    }
  });
  
});

/*
var postcode = localStorage.getItem("postcode");
if(!postcode) {
  window.location.href = '/pages/shop-home?redirect=/pages/suppa-club-soup-cleanse';
}*/